<script setup lang="ts">
import type { NotificationData } from '@/services/notification/models/notification';
import { notificationService } from '@/services/notification/notification-service';
import { useRouter, type RouteLocationRaw } from 'vue-router';

const props = defineProps<{
  notification: NotificationData;
  label: string;
  route: RouteLocationRaw;
  buttonClass?: string | string[];
}>();

const router = useRouter();

function onClick() {
  router.push(props.route);
  notificationService.close(props.notification.id);
}
</script>

<template>
  <button class="notification-action" :class="buttonClass" @click="onClick">
    {{ label }}
  </button>
</template>

<style scoped>
.notification-action {
  all: unset;
  cursor: pointer;
  text-decoration: underline;
}
</style>
